export default "__VITE_ASSET__CkogHrY___"